import classNames from 'classnames';

export type CollapsibleChevronProps = {
    isOpen: boolean;
    size?: string;
    textColour?: string;
}

const CollapsibleChevron = ({isOpen, size, textColour}: CollapsibleChevronProps) => {
    const chevronIconClassName = classNames(
        'mdi',
        {
            'mdi-chevron-up': isOpen,
            'mdi-chevron-down': !isOpen,
            'text-white': !textColour || textColour === "white",
            'text-green': textColour === "green",
            'text-red': textColour === "red",
            'text-black': textColour === "black",
            'text-primary': textColour === "primary",
            'text-secondary': textColour === "secondary",
            'text-success': textColour === "success",
            'text-danger': textColour === "danger",
            'text-warning': textColour === "warning",
            'text-muted': textColour === "muted"
        },
    );

    switch (size) {
        case "0":
            return <span><i className={chevronIconClassName}/></span> 
        case "1":
            return <h1><i className={chevronIconClassName}/></h1> 
        case "2":
            return <h2><i className={chevronIconClassName}/></h2> 
        case "3":
            return <h3><i className={chevronIconClassName}/></h3> 
        case "4":
            return <h4><i className={chevronIconClassName}/></h4> 
        case "5":
            return <h5><i className={chevronIconClassName}/></h5> 
        case "6":
            return <h6><i className={chevronIconClassName}/></h6> 
        default:
            return <h1><i className={chevronIconClassName}/></h1> 
    }

}

export default CollapsibleChevron;